import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=798b554f&scoped=true"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"
import style0 from "./Bills.vue?vue&type=style&index=0&id=798b554f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b554f",
  null
  
)

export default component.exports